import { useRecoilValue } from "recoil";
import { EGameKey, IClipWithTags } from "MVVM/@types";
import { isFaceItPartner } from "MVVM/Utilities/Player";
import { PlaylistIdState } from "MVVM/State/embeddablePlaylist";

import {
  PlaylistClips,
  IClipWithMetadata,
} from "MVVM/Views/EmbeddablePlaylist/@types";

export const buildIframeOptions = (): {
  controls: boolean;
  fluid: boolean;
  defaultVolume: number;
  inline: boolean;
  shouldLoop: boolean;
  useOpenGraphImage: boolean;
} => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const background = params.get("background");
  const volume = Number(params.get("volume")) ?? 1;
  const shouldAllowInlinePlayback = !!params.get("inline");
  const showControls = !background;
  const poster = params.get("pi");
  const playlistId = useRecoilValue(PlaylistIdState);

  return {
    controls: showControls,
    fluid: playlistId ? true : false,
    defaultVolume: volume,
    inline: shouldAllowInlinePlayback,
    shouldLoop: !!background || params.get("loop") === "true",
    useOpenGraphImage: poster === "og",
  };
};

export const shouldRenderSubtitle = (height: number) => {
  if (height <= 550) return false;

  return true;
};

export const shouldRenderTitle = (height: number) => {
  if (height <= 550) return false;

  return true;
};

export const getNumMomentsToRender = (height: number) => {
  if (height > 700) return 3;
  if (height <= 400) return 1;
  if (height <= 700) return 2;

  return 1;
};

export const getWidgetWidth = (width: number) => {
  if (width > 1024) return "50%";
  if (width <= 425) return "70%";
  if (width <= 1024) return "75%";

  return "90%";
};

export const gameKeyToGameName = (gameKey: EGameKey) => {
  switch (gameKey) {
    case EGameKey.CS2:
      return "Counter-Strike";
    case EGameKey.CS_GO:
      return "Counter-Strike";
    case EGameKey.DOTA2:
      return "Dota 2";
    case EGameKey.FORTNITE:
      return "Fortnite";
    case EGameKey.LOL:
      return "League of Legends";
    case EGameKey.OW2:
      return "Overwatch 2";
    default:
      return "Game";
  }
};

export const isFaceItExpiredClip = ({
  clip,
  platform,
}: {
  clip: IClipWithTags;
  platform: string | null;
}) => {
  if (platform && !isFaceItPartner(platform)) return false;

  const isFree4k = clip.tags?.some(
    ({ key, value }) => key === "PARTNER_reason" && value === "free4k",
  );

  const EXPIRY_TIME = 7 * 24 * 60 * 60 * 1000;
  const expired = Date.now() > new Date(clip.createdAt).getTime() + EXPIRY_TIME;

  return !!isFree4k && expired;
};

export const getActiveClipIndex = (
  playlistClips: PlaylistClips | null,
  currentClip: IClipWithMetadata | null,
) => {
  if (!playlistClips || !currentClip) return -1;
  return playlistClips.findIndex(
    (playlistClip) => playlistClip._id === currentClip.id,
  );
};

export const isAdPartner = (platform: string | null) => {
  const queryParams = new URLSearchParams(window.location.search);
  const showAds = queryParams.get("ads");

  return platform && showAds && ["U.GG"].includes(platform);
};
